/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, October 17th 2021, 11:07:10 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import validator from "validator";

export const isDate = (value: string) => !value || validator.isDate(value);

export const isEmail = (value: string) => validator.isEmail(value);

export const isPhoneNumber = (value: string) => {
  if (!value) return true; // if one has not provided a phone number, let the yup validation schema use the required chain to validate if no value is allowed.

  // eslint-disable-next-line
  return value.replace(/\s/g, "").match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)?.length > 0; // https://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
};

export const isDomainName = (domainName: string = "") => !domainName.startsWith("www.") && validator.isFQDN(domainName);

export const isWebHost = (value: string) => {
  const v = value ?? "";

  const isValidWithPort = () => {
    // valid example: 127.0.0.1:9000, 192.168.88.299:55, onestop.co.ke:8989

    return (
      v.split(":").length === 2 &&
      (validator.isIP(v.split(":")[0]) || isDomainName(v.split(":")[0])) &&
      validator.isNumeric(v.split(":")[1])
    );
  };

  return isDomainName(v) || validator.isIP(v) || isValidWithPort();
};

// valid when is null (Yup will handle required validation), size is less than limit or state of file field is the URL from an existing object i.e. typeof === string

export const validateFileSize = (value: File, sizeLimit: number) =>
  !value || value.size <= sizeLimit || typeof value === "string";

export const validateManyAtLeastOne = (value: []) => !value || value.length > 0;

export const validateInternalCSS = (value: string) => !value.includes("body") && !value.includes("html");
